<!--
Description
Displays the date coming from firebase (or whatever) in a dutch readible format.

Usage
<DateFormat :date="date" day time></DateFormat>

@prop date (String): the date to format. ISO format date string.
@prop day (Boolean): if set then return the date
@prop time (Boolean): if set then returns the time

If both are set they are concatenated with a space.

-->


<template>
  <div>{{dateFormat(date)}}</div>
</template>

<script>
export default {
  name: "DateFormat",
  data() {
      return {
      }
  },
  props: {
    date: String,
    day: Boolean,
    time: Boolean
  },
  methods: {
    dateFormat(dd) {
      var d = new Date(dd);
      var daypart = d.getDate() + "-" + (d.getMonth() + 1 < 10 ? "0" : "") + (d.getMonth() + 1) + "-" + d.getFullYear()
      var timepart = ( d.getHours()<10 ? "0" : "" ) + d.getHours() +":" + (d.getMinutes() < 10 ? "0" : "") + d.getMinutes()
      var final = "";
      if(this.day) final += daypart
      if (this.day && this.time) final += " "
      if(this.time) final += timepart

      return final == "" ? "---" : final
    }
  },
 
};
</script>